import { getDateWithSlashes } from '@helpers/date';
import { sendToGTM } from './GTM';

const seoPageCitySelected = (cityID: number) => {
  sendToGTM({
    event: 'seo_page_city_selector_clicked',
    seo_page_cities: {
      city_id: cityID,
    },
  });
};

const seoPageCitySearchClicked = () => {
  sendToGTM({
    event: 'seo_page_city_search_clicked',
  });
};

const seoPageCityDateEntered = (date: Date | undefined) => {
  sendToGTM({
    event: 'seo_page_city_date_entered',
    selected_date: date ? getDateWithSlashes(date) : null,
  });
};

const seoPageCityHotelClicked = (hotelId: number, hotelName: string) => {
  sendToGTM({
    event: 'seo_page_city_hotel_clicked',
    seo_page_cities: {
      hotel_id: hotelId,
      hotel_name: hotelName,
    },
  });
};

export {
  seoPageCitySelected,
  seoPageCitySearchClicked,
  seoPageCityDateEntered,
  seoPageCityHotelClicked,
};
